// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"9c91e44e","213":"1666e52c","221":"0bc5f4b5","239":"ad40150f","257":"6ab3c526","455":"7cd9c36b","925":"218a544d"}[chunkId] + ".chunk.js";
};